import { Box } from "@mui/material";
import type { ReactNode } from "react";

const scoreSectionSx = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  mt: 3,
} as const;

/**
 * Wraps score indicator + metrics list on wellness category cards.
 * Parent should render this only when there is score/data (conditional `{hasScore && …}`)
 * so children are not evaluated when empty and TypeScript narrows correctly.
 */
export function WellnessCategoryScoreSection({
  children,
}: {
  children: ReactNode;
}) {
  return <Box sx={scoreSectionSx}>{children}</Box>;
}
